module.exports = __webpack_public_path__ + "img/upload.3f7e59cc.svg";